import React from 'react';
import PropTypes from 'prop-types';

import { compose, withProps } from 'recompose';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    Circle
} from 'react-google-maps';

const icon = `${window.location.origin.toString()}/assets/img/maps/dot.png`;
const moment = require('moment');
/* global google */

const HistoryMap = compose(
    withProps({
        googleMapURL:
            'https://maps.googleapis.com/maps/api/js?key=AIzaSyC6oQCEcKbgMQ38_EoiudIgZ413ugM1WmA&libraries=geometry,drawing,places',
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: (
            <div
                style={{
                    marginTop: '5px',
                    width: '100%',
                    height: '490px'
                }}
            />
        ),
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(props => {
    //console.log("HistoryMap props :\n", props);
    return (
        <GoogleMap
            zoom={props.zoom}
            center={props.center}
            ref={map => {
                props.onMapMounted(map);
            }}
            onZoomChanged={() => {
                props.onZoomChanged();
            }}
            options={{
                styles: [
                    {
                        featureType: 'poi.business',
                        stylers: [{ visibility: 'off' }]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{ visibility: 'off' }]
                    }
                ]
            }}
        >
            <MarkerStart tour={props.tour} />
            <MarkerStop tour={props.tour} />
            <MarkerVisited color={props.tour.color} points={props.visited} />
            <MarkerUnvisited color={props.tour.color} points={props.unvisited} />
            <RoutePlot routes={props.routes} mppx={props.mppx} />
        </GoogleMap>
    );
});

const _getDistance = (p1, p2) => {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = _rad(p2.lat - p1.lat);
    var dLong = _rad(p2.lng - p1.lng);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(_rad(p1.lat)) *
        Math.cos(_rad(p2.lat)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
};
const _rad = x => {
    return (x * Math.PI) / 180;
};

const MarkerStart = ({ tour }) => {
    let icoStart = `${window.location.origin.toString()}/assets/img/maps/start.png`;
    let mIcon = {
        url: icoStart,
        size: { width: 512, height: 512 },
        anchor: { x: 20, y: 20 },
        scaledSize: { width: 40, height: 40 }
    };
    return (
        <Marker
            key={tour.id}
            position={{ lat: tour.startLat, lng: tour.startLng }}
            icon={mIcon}
            zIndex={999997}
            title={`Started @ ${moment(tour.firstClocked).format(
                'YYYY/MM/DD h:mm:ss A'
            )}`}
        />
    );
};
const MarkerStop = ({ tour }) => {
    let icoStop = `${window.location.origin.toString()}/assets/img/maps/finish.png`;
    let mIcon = {
        url: icoStop,
        size: { width: 512, height: 512 },
        anchor: { x: 20, y: 20 },
        scaledSize: { width: 40, height: 40 }
    };
    return (
        <Marker
            key={tour.id}
            position={{ lat: tour.startLat, lng: tour.startLng }}
            icon={mIcon}
            zIndex={999998}
            title={`Started @ ${moment(tour.lastTimestamp).format(
                'YYYY/MM/DD h:mm:ss A'
            )}`}
        />
    );
};

const MarkerVisited = ({ color, points }) => {
    //console.log("============ MarkerVisited : ", points);

    let icon = `${window.location.origin.toString()}/assets/img/maps/visited_point.png`;
    let seq = 1;
    return points.list.map(serialNumber => {

        let v = points.serialNumber[serialNumber];


        let center = new google.maps.LatLng(v.lat, v.lng);

        let accuracy = 0;
        let radiuses = 0;
        let alpha = 1;

        v.list.forEach(posTimestamp => {
            let clocked = v.posTimestamp[posTimestamp];
            let tagger = new google.maps.LatLng(clocked.posLat, clocked.posLng);

            let radius = google.maps.geometry.spherical.computeDistanceBetween(center, tagger);
            accuracy += clocked.posAcc;
            radiuses += radius;
            alpha += 1;
        });

        alpha = 0.3 + ((0.6 / 30) * alpha);
        if (alpha > 0.9) {
            alpha = 0.9;
        }

        accuracy = accuracy / v.list.length;
        radiuses = radiuses / v.list.length;
        let rColor = `rgba(128, 0, 0, ${alpha}`;


        let mIcon = {
            url: icon,
            size: { width: 100, height: 100 },
            anchor: { x: 20, y: 20 },
            scaledSize: { width: 40, height: 40 },
            labelOrigin: { x: 20, y: 12 }
        };
        let mLabel = {
            color: color,
            text: `${seq++}`,
            fontWeight: 'bold',
            fontSize: '10px'
        };
        return (
            <div key={serialNumber}>
                <Marker
                    key={serialNumber}
                    position={{ lat: v.lat, lng: v.lng }}
                    icon={mIcon}
                    label={mLabel}
                    title={`${v.name} +/- ${accuracy.toFixed(2)} m`}
                />
                <Circle
                    center={{ lat: v.lat, lng: v.lng }}
                    radius={radiuses}
                    options={{
                        strokeColor: rColor, // Color of the perimeter
                        strokeWeight: 0,
                        fillColor: rColor
                    }}
                ></Circle>
            </div>
        );
    });
};

const MarkerUnvisited = ({ color, points }) => {
    let unvisitedMarkers = [];

    let icon = `${window.location.origin.toString()}/assets/img/maps/unvisited_point.png`;
    let seq = 1;
    let mIcon = {
        url: icon,
        size: { width: 100, height: 100 },
        anchor: { x: 20, y: 20 },
        scaledSize: { width: 40, height: 40 },
        labelOrigin: { x: 20, y: 12 }
    };

    points.list.forEach(serialNumber => {
        let p = points.serialNumber[serialNumber];
        let mLabel = {
            color: color,
            text: `${seq++}`,
            fontWeight: 'bold',
            fontSize: '10px'
        };
        unvisitedMarkers.push(
            <div key={serialNumber}>
                <Marker
                    key={serialNumber}
                    position={{ lat: p.lat, lng: p.lng }}
                    icon={mIcon}
                    label={mLabel}
                    title={`${p.name}`}
                    zIndex={9999999}
                />
            </div>
        );
    });
    return unvisitedMarkers;
};

const RoutePlot = ({ routes, mppx }) => {

    let mIcon = {
        url: icon,
        size: { width: 128, height: 128 },
        anchor: { x: 5, y: 5 },
        scaledSize: { width: 10, height: 10 }
    };

    let minDist = 10; //10 meters

    if (mppx) {
        minDist = mppx * 10;
    }
    if (routes.length < 2) {
        return routes.map(r => {
            return (
                <Marker
                    key={r.id}
                    position={{ lat: r.lat, lng: r.lng }}
                    icon={mIcon}
                    zIndex={999999}
                />
            );
        });
    }

    let anchor = routes[0];
    let _routes = [];
    for (var i = 0; i < routes.length; i++) {
        if (i === 0) {
            _routes.push(
                <Marker
                    key={anchor.id}
                    position={{ lat: anchor.lat, lng: anchor.lng }}
                    icon={mIcon}
                    zIndex={999999}
                />
            );
            continue;
        }
        let r = routes[i];
        let d = _getDistance(
            { lat: anchor.lat, lng: anchor.lng },
            { lat: r.lat, lng: r.lng }
        );

        if (d > minDist) {
            anchor = r;
            _routes.push(
                <Marker
                    key={anchor.id}
                    position={{ lat: anchor.lat, lng: anchor.lng }}
                    icon={mIcon}
                    zIndex={999999}
                />
            );
        }
    }
    return _routes;
};

MarkerStart.propTypes = {
    tour: PropTypes.object
};
MarkerStop.propTypes = {
    tour: PropTypes.object
};

HistoryMap.propTypes = {

};

export default HistoryMap;



// WEBPACK FOOTER //
// ./src/components/blocks/HistoryMap/HistoryMap.js